import { render, staticRenderFns } from "./equity-coupons.vue?vue&type=template&id=5b918870&scoped=true&"
import script from "./equity-coupons.vue?vue&type=script&lang=js&"
export * from "./equity-coupons.vue?vue&type=script&lang=js&"
import style0 from "./equity-coupons.vue?vue&type=style&index=0&id=5b918870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b918870",
  null
  
)

export default component.exports